import {CompanySelectorProps, companyType} from "@ots-frontend/ots-data";
import {CompanyMultiSelect, CompanyMultiSelectProps} from "./CompanyMultiSelect";

export type TruckCompanyMultiSelectProps = CompanyMultiSelectProps & {
  selector?: Omit<CompanySelectorProps, 'companyType'>
}

export const TruckCompanyMultiSelect = (props: TruckCompanyMultiSelectProps) => {
  const {selector, ...rest} = props;
  return (
    <CompanyMultiSelect
      {...rest}
      selector={{
        ...selector,
        companyType: companyType.truckCompany,
      }}
    />
  );
};
